@let gridSize = $gridSize();
<div
    class="cm-grid-list"
    [class.cm-grid-list-230]="gridSize === gridSizes.Large"
    [class.cm-grid-list-130]="gridSize === gridSizes.Medium"
    [class.cm-grid-list-110]="gridSize === gridSizes.Small"
>
    <ng-content select="[cm-grid-tiles]"> </ng-content>
</div>
